import { h } from 'preact';
import ShareButton from '../components/ShareButton';
import ChromeLogo from '../components/ChromeLogo';
import { I18nProvider, useTranslation } from '../utils/i18n.jsx';
import translations from '../lang/browserNotSupported.json';

function BrowserNotSupportedContent({ onBack, isChrome, isMobile }) {
  const { t } = useTranslation();

  return (
    <div class="screen">
      <h1>{t('title', { 0: <span class="gradient-text" /> })}</h1>
      <hr></hr>
      <div class="content">
        <div class="copy">
          <p dangerouslySetInnerHTML={{ __html: t('notice', { 0: '<a href="https://developer.chrome.com/docs/devtools/ai-assistance/?utm_source=google-hpp&utm_medium=embedded_marketing_link&utm_campaign=Q4-demo&utm_content=CTA">' }) }}></p>
          <p dangerouslySetInnerHTML={{ __html: t('cta', { 0: '<a href="https://developer.chrome.com/docs/devtools/ai-assistance/?utm_source=google-hpp&utm_medium=embedded_marketing_link&utm_campaign=Q4-demo&utm_content=CTA">' }) }}></p>
        </div>
      </div>
      <hr></hr>
      <div class="controls">
          <div class="back">
          <button class="nav-button back-button" onClick={onBack}>
              &larr; {t('button.back')}
          </button>
          </div>
          <div class="next">
            <ShareButton>{t('button.share')}</ShareButton>
            <a class="button" href="https://developer.chrome.com/docs/devtools/ai-assistance/?utm_source=google-hpp&utm_medium=embedded_marketing_link&utm_campaign=Q4-demo&utm_content=CTA">
              {t('button.learnMore')}
            </a>
          </div>
      </div>
    </div>
  );
}

export function BrowserNotSupported(props) {
  return (
    <I18nProvider translations={translations}>
      <BrowserNotSupportedContent {...props} />
    </I18nProvider>
  );
}


